import React from 'react';
import CallToAction from "@scentregroup/ui/components/call-to-action";
import Container from "@scentregroup/ui/components/container";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { promotionType } from '../../types';
import analyticsUtils from '../../helpers/analytics-utils';
import FlipFlop from '../flip-flop';
import Article from '../article';
import ExternalLink from '../external-link';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  GIFTCARD_CLICK,
  CORP_MODULE_CTA
} = analyticsUtils.categories;

const Promotion = _ref => {
  let {
    image,
    title,
    heading,
    shortDescription,
    callToActionLabel,
    callToActionAddress,
    eventCategory,
    eventAction,
    analyticsMetadata
  } = _ref;
  // N.B. use of a separator to put data for two buttons in one field is a tactical
  // fix to get W+ promotion out ASAP. Should be eventually removed, or replaced with
  // a durable content model solution.
  const SEPARATOR = ';;';
  const [primaryCtaLabel, secondaryCtaLabel] = callToActionLabel.split(SEPARATOR);
  const [primaryCtaAddress, secondaryCtaAddress] = callToActionAddress.split(SEPARATOR);
  const hasSecondary = Boolean(secondaryCtaLabel && secondaryCtaAddress);
  return /*#__PURE__*/_jsx(Container, {
    centred: true,
    type: "large",
    "data-id": "promotion_index_Promotion_Container",
    children: /*#__PURE__*/_jsx(FlipFlop, {
      position: "right",
      size: "full",
      imageUrl: image.url,
      lazyLoad: false,
      analyticsMetadata: analyticsMetadata,
      heading: title,
      "data-id": "promotion_index_Promotion_Container_FlipFlop",
      children: /*#__PURE__*/_jsxs(Article, {
        superheading: heading,
        heading: title,
        "data-id": "promotion_index_Promotion_FlipFlop_Article",
        children: [/*#__PURE__*/_jsx(Paragraph, {
          "data-id": "promotion_index_Promotion_Article_Paragraph",
          children: shortDescription
        }), /*#__PURE__*/_jsxs(Container, {
          type: "full",
          className: styles.ctaContainer,
          "data-id": "promotion_index_Promotion_Article_Container",
          children: [/*#__PURE__*/_jsx(CallToAction, {
            rel: 'noopener',
            target: '_self',
            element: ExternalLink,
            url: primaryCtaAddress,
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: primaryCtaLabel,
            "data-test-id": "promotion-link",
            fullWidth: hasSecondary,
            "data-id": "promotion_index_Promotion_Container_CallToAction",
            children: primaryCtaLabel
          }), hasSecondary && /*#__PURE__*/_jsx(CallToAction, {
            rel: 'noopener',
            target: '_self',
            inferior: true,
            fullWidth: true,
            element: ExternalLink,
            url: secondaryCtaAddress,
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: secondaryCtaLabel,
            "data-test-id": "promotion-link",
            "data-id": "promotion_index_Promotion_CallToAction_6",
            children: secondaryCtaLabel
          })]
        })]
      })
    })
  });
};

Promotion.defaultProps = {
  eventCategory: GIFTCARD_CLICK,
  eventAction: CORP_MODULE_CTA
};
export default Promotion;